import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Class, Staff, Events, Payments } from ".";
import ComingSoon from "../../subComponents/ComingSoon";

import encryptor from "../../utils/encryptor";
import Menu from "../../subComponents/Menu";
import { staffThunk, classesThunk } from "../../redux/adminSlice";
import { updateStudentsData } from "../../firebase/functions";

const Admin = () => {
  const [auth, setAuth] = useState(() => {
    const hashVal = window.localStorage.getItem("_auth");
    if (!hashVal) return false;
    return encryptor.decrypt(hashVal) === "true" ? true : false;
  });

  const [section, setSection] = useState("staff");

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const sectionMap = {
    events: "upcoming events",
    payments: "payments & fees",
  };

  useEffect(() => {
    const hashVal = window.localStorage.getItem("_auth");
    if (!hashVal) {
      navigate("/admin/login");
      return;
    }
    if (encryptor.decrypt(hashVal) === "false") {
      navigate("/admin/login");
      return;
    }

    dispatch(staffThunk());
    dispatch(classesThunk());
    updateStudentsData();
  }, []);

  if (auth)
    return (
      <Grid container style={{ height: "100vh" }}>
        <Grid item xs={3}>
          <Menu
            setSection={setSection}
            menuSections={[
              { subHeader: "Financials", subItem: ["Payments & Fees"] },
              {
                subHeader: "Administrative",
                subItem: ["Class", "Students", "Staff"],
              },
              { subHeader: "Utilities", subItem: ["Upcoming Events"] },
            ]}
          />
        </Grid>
        <Grid item xs={9}>
          {section === "" && <ComingSoon />}
          {section === "class" && <Class />}
          {section === "staff" && <Staff />}
          {section === sectionMap["events"] && <Events />}
          {section === sectionMap["payments"] && <Payments />}
        </Grid>
      </Grid>
    );
  else return <UnAuthorized />;
};

export default Admin;

const UnAuthorized = () => (
  <Grid container alignItems="center" bgcolor="primary.main" height="100vh">
    <Typography variant="h2" color="white" width="100%" align="center">
      UnAuthorized page access{" "}
      <span style={{ color: "#f00", fontWeight: "bold" }}>403</span>
    </Typography>
  </Grid>
);
